import { logUiEvent as defaultLog } from '../../services/uiLogger';
import { shouldExtract } from './threshold';

/** Держать в согласии с MAX_AUDIO_DURATION_SECONDS бэкенда
 *  (bit-transcribe-v3/app/config.py:48). При расхождении лишний файл просто
 *  доедет до сервера и получит отказ там — деградация мягкая. */
export const MAX_DURATION_SECONDS = 6 * 3600;

const extOf = (name) => (name || '').split('.').pop().toLowerCase();

export async function extractAudio(file, { onProgress, signal, maxDurationSec, deps } = {}) {
  const logUiEvent = (deps && deps.logUiEvent) || defaultLog;
  const now = (deps && deps.now) || (() => Date.now());

  if (!shouldExtract(file)) return { file: null, reason: 'below_threshold' };

  // spawn.js содержит import.meta, на котором babel-jest в CRA 5 падает ещё
  // при разборе графа импортов — поэтому грузим его динамически и только
  // когда воркер действительно нужен. Юниты подменяют runInWorker через deps
  // и до этой строки не доходят, а значит и до import.meta тоже.
  const runInWorker = (deps && deps.runInWorker)
    || (await import('./spawn')).runInWorker;

  const startedAt = now();
  const result = await runInWorker(file, {
    onProgress, signal,
    maxDurationSec: maxDurationSec || MAX_DURATION_SECONDS,
  });

  const meta = {
    ok: !!result.ok,
    path: result.ok ? result.path : 'fallback',
    reason: result.reason || '',
    src_bytes: file.size,
    out_bytes: result.ok ? result.blob.size : 0,
    src_ext: extOf(file.name),
    duration_sec: result.ok ? Math.round(result.durationSec) : 0,
    ms: now() - startedAt,
    ua: typeof navigator === 'undefined' ? '' : navigator.userAgent,
  };
  try {
    logUiEvent('audio_extract', { component: 'transcription', meta });
  } catch (e) {
    // Метрика важна, но не важнее результата — не роняем извлечение.
  }

  if (!result.ok) return { file: null, reason: result.reason };

  return {
    file: new File([result.blob], result.name, { type: result.blob.type }),
    path: result.path,
    srcBytes: file.size,
    outBytes: result.blob.size,
  };
}
